'use client';

import { TranslatedProjects } from '@/components/shared';
import { QueryWrapper } from '@/components/shared/query-wrapper';
import { ProjectGrid } from '@/features/projects/components/project-grid';
import { useProjects } from '@/shared/hooks';
import type { FC } from 'react';

const ProjectsGridWithReactQuery: FC = () => {
  const { data: projects, isLoading, error } = useProjects();

  return (
    <QueryWrapper isLoading={isLoading} error={error} data={projects}>
      {(projects) => (
        <TranslatedProjects
          projects={projects}
          renderProjects={(projects) => <ProjectGrid projects={projects} />}
        />
      )}
    </QueryWrapper>
  );
};

export const ProjectsBlock: FC = () => {
  return <ProjectsGridWithReactQuery />;
};
